export const transformPercentage = (amount: number) => {
  return amount / 100;
};
